import { Component, forceUpdate, Host, h, Prop } from "@stencil/core";
import {
    getDiscontinuationStatusIcon,
    getDiscontinuationStatusColor,
} from "../../utils/discontinuationStatus";
import { i18nProvider } from "@trumpf/ux.i18n";

@Component({
    tag: "ux-iws-discontinuation-tooltip",
    styleUrl: "discontinuation-tooltip.scss",
    shadow: false,
})
export class DiscontinuationTooltip {
    /** discontinuation info */
    @Prop() status: string;
    /** string info */
    @Prop() type: string;
    /** string info */
    @Prop() extendedSupport: boolean;
    /** string info */
    @Prop() head: string;
    /** string info */
    @Prop() text: string;
    /** string info */
    @Prop() link: string;
    /** string info */
    @Prop() linkText: string;
    /** unique string that identifies the tooltip */
    @Prop() tooltipIdentifier: string;

    private i18nSubscriberId: string;

    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
    }

    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }

    render() {
        const { t } = i18nProvider;
        const {
            type,
            status,
            extendedSupport,
            head,
            text,
            link,
            linkText,
            tooltipIdentifier,
        } = this;

        return (
            <Host class="ux-iws-discontinuation-tooltip">
                <ux-tooltip
                    tooltip-target={`[data-tooltip-id=ux-iws-${tooltipIdentifier}]`}
                    align="top"
                >
                    <div class="flex flex--col flex--align-center">
                        <span
                            style={{
                                color: `${getDiscontinuationStatusColor(
                                    status
                                )}`,
                            }}
                        >
                            <ux-icon
                                name={getDiscontinuationStatusIcon(
                                    status,
                                    type,
                                    extendedSupport
                                )}
                                size-l="44"
                                weight="normal"
                            ></ux-icon>
                        </span>
                        <h6 class="ux-u-margin-left-10 ux-u-margin-top-5 ux-u-margin-bottom-0 ux-text-headline ux-text-headline--small ux-u-text-align--center">
                            {head}
                        </h6>
                    </div>
                    <p class="ux-text-normal">{text}</p>
                    <a
                        href={link}
                        class="ux-text-link ux-text-link--green ux-text-normal"
                    >
                        {linkText || t("machineDiscontinuation.linkText")}{" "}
                        <ux-icon name="arrow-small-right" />
                    </a>
                </ux-tooltip>
                <div class="ux-iws-discontinuation-tooltip__slot">
                    <slot />
                </div>
            </Host>
        );
    }
}
